module.exports = __webpack_public_path__ + "img/downsp.09b2e3c1.jpg";